export var ColorPool: {
  [key: string]: { label: { [key: string]: string }; colors: string[] };
} = {
  off: {
    label: { cs: "Vypnout", en: "Off" },
    colors: [
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
      "#FFF",
    ],
  },
  pastelLow: {
    label: { cs: "Světlé pastely", en: "Light pastely" },
    colors: [
      "#ffe0b2",
      "#ffcdd2",
      "#e1bee7",
      "#c5cae9",
      "#b3e5fc",
      "#b2dfdb",
      "#dcedc8",
      "#fff9c4",
      "#ffccbc",
      "#f8bbd0",
      "#d1c4e9",
      "#bbdefb",
      "#b2ebf2",
      "#c8e6c9",
      "#f0f4c3",
      "#ffecb3",
    ],
  },
  pastelHigh: {
    label: { cs: "Tmavé pastely", en: "Dark pastel" },
    colors: [
      "#ff9e80",
      "#ff8a80",
      "#ea80fc",
      "#8c9eff",
      "#80d8ff",
      "#a7ffeb",
      "#ccff90",
      "#ffff8d",
      "#ffd180",
      "#ff80ab",
      "#b388ff",
      "#82b1ff",
      "#84ffff",
      "#b9f6ca",
      "#f4ff81",
      "#ffe57f",
    ],
  },
};
